<template>
  <section class="whiteBox">
    <div class="content">
      <h1 v-if="!this.$route.params.id">{{$t('createCampaign.title')}}</h1>
      <h1 v-else>{{$t('campaigns.modifyCampaignAction')}}</h1>
    </div>
    <div class="row">
      <div class="formBox accentuate blueSelect">{{$t('createCampaign.uniqueCoupon')}}</div>
    </div>
    <div class="row whiteBg">
      <i class="far fa-dot-circle blueColor"></i>
      <p class="tips blueColor">{{$t('createCampaign.generalDescription')}}</p>
      <div class="separator blueColor"></div>
      <i class="far fa-dot-circle blueColor"></i>
      <p class="tips">{{$t('createCampaign.couponDescription')}}</p>
      <div class="separator"></div>
      <i class="far fa-dot-circle"></i>
      <p class="tips">{{$t('createCampaign.associateProduct')}}</p>
    </div>
    <div class="content">
      <p class="accentuate">{{$t('createCampaign.descriptionCoupon')}}</p>
      <div class="spacer"></div>
      <label>{{$t('coupons.couponCode')}}</label>
      <span
        class="errorSentence"
        v-if="!isGlobalCodeFilled && isSubmitted"
      >* {{$t('error.textFieldRequired')}}</span>
      <div class="row">
        <div class="demiRow">
          <input
            type="text"
            v-model="values['global-code']"
            v-bind:class="{ 'error' : !isGlobalCodeFilled && isSubmitted}"
          >
        </div>
        <p class="tips">{{$t('coupons.couponCodeTips')}}</p>
      </div>
      <br>
      <label>{{$t('createCampaign.useByClient')}}</label>
      <span
        class="errorSentence"
        v-if="!isMaxNumberOfUsesPerClientSet && isSubmitted"
      >* {{$t('error.textFieldRequired')}}</span>
      <div class="row">
        <div class="dataEndInput">
          <p>{{$t('createCampaign.number')}}</p>
          <input
            type="number"
            v-bind:class="{ 'error' : !isMaxNumberOfUsesPerClientSet && isSubmitted,'mInput' :true}"
            v-model="values['max-number-of-uses-per-client']"
          >
        </div>
        <p class="tips">{{$t('createCampaign.useByClientTips')}}</p>
      </div>
      <label>{{$t('createCampaign.totalUse')}}</label>
      <span
        class="errorSentence"
        v-if="!isMaxNumberOfUsesSet && isSubmitted"
      >* {{$t('error.textFieldRequired')}}</span>
      <div class="row">
        <div class="dataEndInput">
          <p>{{$t('createCampaign.number')}}</p>
          <input
            type="number"
            v-bind:class="{ 'error' : !isMaxNumberOfUsesSet && isSubmitted,'mInput' :true}"
            v-model="values['max-number-of-uses']"
          >
        </div>
        <p class="tips">{{$t('createCampaign.totalUseTips')}}</p>
      </div>
    </div>
    <hr>
    <div class="content">
      <div class="row">
        <button @click="next()">{{$t('button.next')}}</button>
        <button
          @click="$emit('return');$emit('updatecampaign', values);"
          class="outline"
        >{{$t('button.back')}}</button>
        <a @click="goBack">{{$t('button.cancel')}}</a>
      </div>
    </div>
  </section>
</template>

<script>
import GroupsOfDiscounts from "@/services/GroupsOfDiscounts";
export default {
  props: ["parCampaign", "parGroupOfDiscounts"],
  mounted() {
    this.initValues();
  },
  data() {
    return {
      isSubmitted: false,
      values: {
        id: "",
        "max-number-of-uses": "",
        "max-number-of-uses-per-client": "",
        "global-code": ""
      }
    };
  },
  computed: {
    isGlobalCodeFilled: function() {
      if (this.values["global-code"]) return true;
      return false;
    },
    isMaxNumberOfUsesSet: function() {
      if (this.values["max-number-of-uses"]) return true;
      return false;
    },
    isMaxNumberOfUsesPerClientSet: function() {
      if (this.values["max-number-of-uses-per-client"]) return true;
      return false;
    }
  },
  methods: {
    initValues() {
      if (this.parGroupOfDiscounts) {
        this.values = this.parGroupOfDiscounts;}
      else
      {
        GroupsOfDiscounts.get(this.parCampaign.id).then(res => {
          if (res.status == 200) {
            if (res.data[0]) this.values = res.data[0];
          }
        });
      }
    },
    goBack() {
      if (this.parCampaign["status"] == 0)
        this.$router.push({
          name: "allCampaigns",
          params: { campaignType: "active" }
        });
      else
        this.$router.push({
          name: "detailUniqueCampaign",
          params: { id: this.$route.params.id }
        });
    },
    next() {
      this.isSubmitted = true;
      if (
        this.isGlobalCodeFilled &&
        this.isMaxNumberOfUsesSet &&
        this.isMaxNumberOfUsesPerClientSet
      ) {
        this.$emit("updatecampaign", this.values);
        this.$emit("next");
      }
    }
  }
};
</script>
      